import React from 'react';
import classnames from 'classnames';

import Icon, { IconName, iconsMap } from '../../../common/components/icon/Icon';
import './POIIcon.scss';
import { GeocodingFeature } from '../../../common/types/mapbox-search-api-v1.types.ts';

export const defaultIconName = 'default-poi';

const getIconName = (poi: GeocodingFeature | undefined) => {
  if (!poi) {
    return defaultIconName;
  }

  const makiIconName = `${poi.properties.maki}-poi`;

  if (makiIconName in iconsMap) {
    return makiIconName;
  }

  return defaultIconName;
};

export interface POIIconProps {
  className?: string;
  gray?: boolean;
  poi?: GeocodingFeature;
}

const POIIcon = ({ className, poi, gray }: POIIconProps) => (
  <div className={classnames('poi-icon', className, { gray })}>
    <Icon name={getIconName(poi) as IconName} />
  </div>
);

export default POIIcon;
